import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { MenuItem } from "../../MenuItem";
export var Item = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Item, _React$Component);

  function Item() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Item.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(MenuItem, {
      isNotSelectable: this.props.isNotSelectable
    }, this.props.children);
  };

  return Item;
}(React.Component);
Item.__KONTUR_REACT_UI__ = 'SelectItem';
Item.displayName = 'SelectItem';